//! @ngInject
export function historyTimelineModalCtrl($scope, $uibModalInstance, tables) {
    $scope.tables = tables;
    $scope.closeModal = function () {
        $uibModalInstance.close();
    };
};
